import React, { useEffect, useState } from "react";
import DelarRegistrationContactSection from "../../components/DelarInfo/DelarRegistrationContactSection";
import BasicSelectInput from "../../components/FormComponent/BasicSelectInput";
import { MixedSelectAndInputField } from "../../components/FormComponent/MixedSelectAndInputField";
import {
  BasicTextInput,
  MultiTextInput,
} from "../../components/FormComponent/BasicTextInput";
import { CustomRadioButton } from "../../components/FormComponent/CustomRadioButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AttachMini,
  CameraMini,
  ChevronLeftMini,
  CrossFillMini,
  UploadMini,
} from "../../assets/SvgIcons";
import axiosInstance from "../../redux/helpers/axios";
import toast from "react-hot-toast";
import axios from "axios";
import { useDispatch } from "react-redux";
import { signUp } from "../../redux/actions";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
  "pk_test_51R9obOD3aOjgfiPq9eq4Nt6UbLaMp5Vsedd7X6o7tSFSfuZKUL4zbbCTt6FT3mwATaLhLV0ilVMFEFYWwXKngPgZ00YrpS5VeC"
);

const countryCodeOptions = [
  "🇦🇺 +61",
  "UAE +971",
  "🇧🇩 +880",
  "🇧🇪 +32",
  "🇧🇷 +55",
  "🇨🇦 +1",
  "🇨🇳 +86",
  "🇨🇭 +41",
  "🇩🇪 +49",
  "🇪🇸 +34",
  "🇫🇷 +33",
  "🇬🇧 +44",
  "🇮🇩 +62",
  "🇮🇱 +972",
  "🇮🇳 +91",
  "🇯🇵 +81",
  "🇰🇷 +82",
  "🇰🇼 +965",
  "🇲🇾 +60",
  "🇲🇽 +52",
  "🇳🇱 +31",
  "🇳🇴 +47",
  "🇳🇿 +64",
  "🇵🇱 +48",
  "🇵🇭 +63",
  "🇺🇦 +380",
  "🇺🇸 +1",
  "🇮🇪 +353",
  "🇷🇺 +7",
  "🇸🇬 +65",
  "🇸🇪 +46",
  "🇹🇷 +90",
  "🇺🇦 +380",
  "🇿🇦 +27",
];

const countyNameOptions = [
  "UAE",
  "Australia",
  "Bangladesh",
  "Belgium",
  "Brazil",
  "Canada",
  "China",
  "Switzerland",
  "Germany",
  "Spain",
  "France",
  "United Kingdom",
  "Indonesia",
  "Israel",
  "Ireland",
  "India",
  "Japan",
  "South Korea",
  "Kuwait",
  "Malaysia",
  "Mexico",
  "Netherlands",
  "Norway",
  "New Zealand",
  "Poland",
  "Philippines",
  "Russia",
  "Singapore",
  "Sweden",
  "Ukraine",
  "United States",
  "South Africa",
  "Turkey",
  "Austria",
];

const DelarRegistration = () => {
  return (
    <>
      <DelarRegistrationForm />
      <DelarRegistrationContactSection />
    </>
  );
};

export default DelarRegistration;

const DelarRegistrationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const { amount, cycle } = location.state || {};

  console.log(amount);

  const currentStep =
    (location?.search && +location?.search?.split("=")[1]) || 1;

  // console.log(currentStep);

  const [steps, setSteps] = useState([
    {
      stepNo: 1,
      stepName: "Dealer account",
      isActive: true,
      isCurrent: true,
    },
    {
      stepNo: 2,
      stepName: "Documents",
      isActive: false,
      isCurrent: false,
    },
    {
      stepNo: 3,
      stepName: "Payment",
      isActive: false,
      isCurrent: false,
    },
    // {
    //   stepNo: 4,
    //   stepName: "Payout information",
    //   isActive: false,
    //   isCurrent: false,
    // },
    {
      stepNo: 5,
      stepName: "Summary",
      isActive: false,
      isCurrent: false,
    },
  ]);
  const [formData1, setFormData1] = useState({
    companyTitle: "",
    businessType: "",
    country: "UAE",
    fullName: "",
    email: "",
    phone: "",
    countryCode: "UAE +971",
    password: "",
    confirmPassword: "",
    preferredLanguage: "",
  });

  const [formData2, setFormData2] = useState({
    avatar: "",
    tl: "",
  });
  const [formData3, setFormData3] = useState({
    paymentMethod: "",
    cardHolder: "",
    cardNumber: "",
    cvc: "",
    expDate: "",
  });
  const [formData4, setFormData4] = useState({
    paymentMethod: "",
    cardHolder: "",
    cardNumber: "",
    cvc: "",
    expDate: "",
  });
  const [formData5, setFormData5] = useState({
    allowOurPolicy: false,
  });

  const handleChangeFormData1 = (e) => {
    const { name, value } = e.target;
    setFormData1({
      ...formData1,
      [name]: value,
    });
  };

  const handleChangeFormData2 = (e) => {
    const { name, value } = e.target;
    setFormData2({
      ...formData2,
      [name]: value,
    });
  };
  const handleChangeFormData3 = (e) => {
    const { name, value } = e.target;
    setFormData3({
      ...formData3,
      [name]: value,
    });
  };
  const handleChangeFormData4 = (e) => {
    const { name, value } = e.target;
    setFormData4({
      ...formData4,
      [name]: value,
    });
  };
  const handleChangeFormData5 = (e) => {
    const { name, value } = e.target;
    setFormData5({
      ...formData5,
      [name]: value,
    });
  };

  const handleRadioChange2 = (e, isTrue) => {
    const { name, id } = e.target;

    setFormData2((prevData) => ({
      ...prevData,
      [name]: id === isTrue ? true : false,
    }));
  };

  const handleNextStep = (stepNo) => {
    navigate(`/dealer-info/registration-info?step=${stepNo}`, {
      state: { amount: amount, cycle: cycle },
    });
    let temp = steps?.map((step) => {
      if (step?.stepNo === stepNo) step.isCurrent = true;
      else step.isCurrent = false;

      if (step?.stepNo <= stepNo) step.isActive = true;
      else step.isActive = false;
      return step;
    });
    setSteps((current) => temp);
    // console.log(temp);
  };

  const handleSubmitDealerRegistration = () => {
    console.log(formData1, formData2, formData3, formData4);
    dispatch(signUp({ ...formData1, ...formData2 }));
  };

  return (
    <>
      <StepIndicator steps={steps} handleNextStep={handleNextStep} />
      <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-8 md:py-6 sm:py-6 ">
        <Step1Section
          // isActive={steps[0]?.isCurrent}
          isActive={currentStep === 1}
          formData1={formData1}
          handleChangeFormData1={handleChangeFormData1}
          handleNextStep={handleNextStep}
        />
        <Step2Section
          // isActive={steps[1]?.isCurrent}
          isActive={currentStep === 2}
          formData2={formData2}
          setFormData2={setFormData2}
          handleChangeFormData2={handleChangeFormData2}
          handleNextStep={handleNextStep}
          handleRadioChange2={handleRadioChange2}
        />
        <Step3Section
          // isActive={steps[2]?.isCurrent}
          isActive={currentStep === 3}
          formData3={formData3}
          handleChangeFormData2={handleChangeFormData3}
          handleNextStep={handleNextStep}
          amount={amount}
          cycle={cycle}
        />
        {/* <Step4Section
          // isActive={steps[3]?.isCurrent}
          isActive={currentStep===4}
          formData4={formData4}
          handleChangeFormData4={handleChangeFormData4}
          handleNextStep={handleNextStep}
        /> */}
        <Step5Section
          // isActive={steps[3]?.isCurrent}
          isActive={currentStep === 5}
          formData5={formData5}
          handleChangeFormData5={handleChangeFormData5}
          handleNextStep={handleNextStep}
          //
          handleSubmitDealerRegistration={handleSubmitDealerRegistration}
        />
      </section>
    </>
  );
};

const StepIndicator = ({ steps, handleNextStep }) => {
  return (
    <div className="border-b pt-2 mb-2">
      <nav className="grid grid-cols-5  max-w-[1200px] mx-auto px-2 ">
        {steps?.map((step, index) => {
          return (
            <button
              key={index}
              className={`border-b-2 ${
                step?.isActive
                  ? "text-primary border-b-primary"
                  : "text-black border-b-white"
              } `}
              onClick={() => handleNextStep(step?.stepNo)}
            >
              <div className="text-left px-2 flex items-end">
                <p className="text-[36px]">{index + 1}</p>
                <p
                  className={`text-[14px] ml-3 lg:block pb-[10px] ${
                    step?.isCurrent ? "md:block" : "md:hidden"
                  } sm:hidden `}
                >
                  {step?.stepName}
                </p>
              </div>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

const TrialBanner = ({ icon, title, desctiption }) => {
  return (
    <div className="flex flex-col space-y-4 p-4 border  rounded-lg">
      <div className="flex items-center space-x-2">
        <span className="text-highlight text-xl">{icon}</span>
        <p className="text-sm font-semibold m-0">{title}</p>
      </div>

      <div className="border-t border-gray-300"></div>

      <div className="text-gray-700 text-xs">{desctiption}</div>
    </div>
  );
};

const Step1Section = ({
  isActive,
  handleNextStep,
  handleChangeFormData1,
  formData1,
}) => {
  const nextStep = () => {
    if (
      formData1.companyTitle !== "" &&
      formData1?.country !== "" &&
      formData1?.fullName !== "" &&
      formData1?.email !== "" &&
      formData1?.countryCode !== "" &&
      formData1?.phone !== "" &&
      formData1?.password !== "" &&
      formData1?.confirmPassword !== ""
    ) {
      handleNextStep(2);
    } else {
      toast.error("Please fill all the required fields.", { duration: 1000 });
    }
  };
  return (
    <div className={`${isActive ? "block" : "hidden"} gap-4`}>
      <div className="lg:w-8/12 md:w-8/12 sm:w-full">
        <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
          Create Your Dealer Account
        </h1>
        <p className="text-[14px] mt-4">
          First, we need some basic information about your business. You'll be
          able to create the login information for your dealer account in the
          next step.
        </p>
      </div>

      <div className="my-6 flex gap-4">
        <form className="lg:w-8/12 md:w-8/12 sm:w-full">
          <BasicTextInput
            label={"Company"}
            isRequired={true}
            type={"text"}
            id={"companyTitle"}
            name={"companyTitle"}
            value={formData1?.companyTitle}
            onChange={handleChangeFormData1}
            placeholder={"Enter your company name"}
            tooltip={
              "Please enter your company's name as you would like it to appear next to your listings."
            }
          />
          {/* <BasicSelectInput
            label={"Type of business"}
            isRequired={true}
            name={"businessType"}
            onChange={handleChangeFormData1}
            value={formData1?.businessType}
            options={["Individual", "Corporation"]}
            defaultDisabledValue={"Please select"}
          /> */}
          <BasicSelectInput
            label={"Country"}
            isRequired={true}
            name={"country"}
            onChange={handleChangeFormData1}
            value={formData1?.country}
            options={countyNameOptions}
            defaultDisabledValue={"UAE"}
          />
          {/* <BasicSelectInput
            label={"Title"}
            name={"title"}
            onChange={handleChangeFormData1}
            value={formData1?.title}
            options={["Prefer not to say", "Mr", "Ms", "Mx"]}
            defaultDisabledValue={"Prefer not to say"}
          /> */}
          <BasicTextInput
            label={"Full name"}
            isRequired={true}
            type={"text"}
            id={"fullName"}
            name={"fullName"}
            value={formData1?.fullName}
            onChange={handleChangeFormData1}
            placeholder={"Enter your full name"}
          />
          {/* <BasicTextInput
            label={"Last name (billing address)"}
            isRequired={true}
            type={"text"}
            id={"lastName"}
            name={"lastName"}
            value={formData1?.lastName}
            onChange={handleChangeFormData1}
            placeholder={"Enter your lastName name"}
          /> */}
          <BasicTextInput
            label={"Email address"}
            isRequired={true}
            type={"email"}
            id={"email"}
            name={"email"}
            value={formData1?.email?.toLowerCase()}
            onChange={handleChangeFormData1}
            placeholder={"Enter your email "}
          />

          <MixedSelectAndInputField
            label="Phone Number"
            value1={formData1?.countryCode}
            onChange1={handleChangeFormData1}
            options1={countryCodeOptions}
            name1="countryCode"
            //
            defaultDisabledValue1="UAE +971"
            value2={formData1?.phone}
            onChange2={handleChangeFormData1}
            id2="phone"
            name2="phone"
            isRequired={true}
          />

          <div className="border-b w-full my-8" />

          {/* <BasicTextInput
            label={"Account username"}
            isRequired={true}
            type={"text"}
            id={"username"}
            name={"username"}
            value={formData1?.username}
            onChange={handleChangeFormData1}
            placeholder={"Enter your username"}
          /> */}

          <BasicTextInput
            label={"Account password"}
            isRequired={true}
            type={"password"}
            id={"password"}
            name={"password"}
            value={formData1?.password}
            onChange={handleChangeFormData1}
            placeholder={"Enter your password "}
          />
          <BasicTextInput
            label={"Re-enter Password"}
            isRequired={true}
            type={"password"}
            id={"confirmPassword"}
            name={"confirmPassword"}
            value={formData1?.confirmPassword}
            onChange={handleChangeFormData1}
            placeholder={"Confirm your Password "}
          />

          <div className="border-b w-full my-8" />

          <BasicSelectInput
            label={"Preferred language"}
            name={"preferredLanguage"}
            onChange={handleChangeFormData1}
            value={formData1?.preferredLanguage}
            options={["English", "Arabic", "Persian", "Hindi"]}
            defaultDisabledValue={"-"}
          />

          {/* CTA TO NEXT PAGE */}
          <div className="flex justify-between items-center w-full my-6">
            <div />
            <button
              onClick={(e) => {
                e.preventDefault();
                nextStep();
              }}
              className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
            >
              Continue to step 2
            </button>
          </div>
        </form>

        {/* <div className="lg:w-4/12 md:w-4/12 pl-6 sm:w-full lg:block md:block sm:hidden">
          <TrialBanner
            icon={"💡"}
            title={"Start Your 30-Day Trial Now"}
            desctiption={
              " Become a dealer on WristLink  and reach millions of watch enthusiasts from   around the globe. Try it out: There’s no base fee for the first 30 days. We only charge a commission fee for successful sales."
            }
          />
        </div> */}
      </div>
    </div>
  );
};

const Step2Section = ({
  isActive,
  handleNextStep,
  handleChangeFormData2,
  formData2,
  setFormData2,
  handleRadioChange2,
}) => {
  const [tradeLicence, setTradeLicence] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [preview, setPreview] = useState("");
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const nextStep = () => {
    if (formData2.tl !== "" && formData2.avatar !== "") {
      handleNextStep(3);
    } else {
      toast.error("Please upload all the documents.", { duration: 1000 });
    }
  };

  const handleTradeLicense = async (event) => {
    const file = event.target.files[0];
    setTradeLicence(event.target.files[0]);
    setUploadPercentage(0);
    event.target.value = null;
  };

  const handleCompanyImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
      setPreview(reader.result);
    }
  };

  const generateLinkFromString = (str) => {
    return str?.split("")?.length > 0
      ? `${Math.floor(1000000000 + Math.random() * 9000000000)}-${str
          ?.toLowerCase()
          ?.replace(/\s+/g, "-")}`
      : ""; // Replace spaces (or multiple spaces) with hyphens
  };

  const handleImgUpload = async (file) => {
    const id = toast.loading("Loading...");
    try {
      const response = await axiosInstance.get(`/utils/aws/get-presigned-url`, {
        params: {
          filename: generateLinkFromString(file.name),
          fileType: file.type,
        },
      });

      const { url, objectUrl } = response.data;
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      toast.dismiss(id);

      setFormData2({ ...formData2, ["avatar"]: objectUrl });
    } catch (error) {
      console.log(error);

      toast.error("Image upload failed!", { id: id });
    }
  };

  const handleFileUpload = async (file) => {
    const id = toast.loading("Loading...");
    try {
      const response = await axiosInstance.get(`/utils/aws/get-presigned-url`, {
        params: {
          filename: generateLinkFromString(file.name),
          fileType: file.type,
        },
      });

      const { url, objectUrl } = response.data;
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadPercentage(percentCompleted); // Update the upload percentage
        },
      });
      toast.dismiss(id);

      setFormData2({ ...formData2, ["tl"]: objectUrl });
    } catch (error) {
      console.log(error);

      toast.error("Trade License upload failed!", { id: id });
    }
  };

  const handleFileRemove = () => {
    setTradeLicence(null);
    setFormData2({ ...formData2, ["tl"]: "" });
  };
  console.log(formData2);

  return (
    <div className={`${isActive ? "block" : "hidden"} gap-4`}>
      <div className="lg:w-8/12 md:w-8/12 sm:w-full">
        <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
          Additional company information
        </h1>
        <p className="text-[14px] mt-4">
          Plesse submit the Trade License of your company & Logo.
        </p>
      </div>

      <div className="my-6 flex gap-4">
        <form className="lg:w-8/12 md:w-8/12 sm:w-full">
          {/* IMAGE INPUT */}
          <div className="mt-8 flex justify-center">
            <input
              onChange={(e) => {
                handleCompanyImage(e);
                setCompanyLogo(e.target.files[0]);
                handleImgUpload(e.target.files[0]);
              }}
              type="file"
              id="LogoUpload"
              className="hidden"
              multiple
            />

            <label
              htmlFor="LogoUpload"
              className="p-4 border border-secondary text-secondary border-dashed py-3.5 rounded-lg w-fit  flex  justify-center items-center gap-6 cursor-pointer"
            >
              {!preview ? (
                <div className="h-[150px] w-[150px] rounded-full border flex justify-center items-center">
                  {CameraMini}
                </div>
              ) : (
                <img
                  src={preview}
                  alt=""
                  height={120}
                  width={120}
                  className="h-[150px] w-[150px] rounded-full border"
                />
              )}

              <p className="text-[14px] font-medium underline">
                {companyLogo === null ? "Upload Company Logo" : "Change"}
              </p>
            </label>
          </div>
          {/* TRADE LICENCE INPUT */}
          <div className="mt-8">
            {tradeLicence && (
              <div
                style={{
                  background: `linear-gradient(to right, #228B22 ${uploadPercentage}%, #D2D1CA ${uploadPercentage}%)`,
                }}
                className="flex justify-between items-center rounded-full p-2 bg-primary text-secondary mb-4"
              >
                <div className="flex items-center gap-2 ">
                  {AttachMini}
                  <p className="text-[14px] font-semibold ">
                    {tradeLicence?.name}
                  </p>
                </div>{" "}
                <div
                  className="cursor-pointer "
                  onClick={() => handleFileRemove()}
                >
                  {CrossFillMini}
                </div>
              </div>
            )}
            <input
              onChange={(e) => {
                handleFileUpload(e.target.files[0]);
                handleTradeLicense(e);
              }}
              type="file"
              id="fileUpload"
              className="hidden"
              multiple
            />

            <label
              htmlFor="fileUpload"
              className="border border-primary text-primary border-dashed py-3.5 rounded-lg w-full  flex justify-center items-center gap-2 bg-secondarylight cursor-pointer"
            >
              {UploadMini}
              <p className="text-[14px] font-medium ">Upload Trade Licence</p>
            </label>
          </div>

          {/* BASIC FORM ######START */}
          {/* <div>
            <BasicTextInput
              label={"Street"}
              isRequired={true}
              type={"text"}
              id={"street"}
              name={"street"}
              value={formData2?.street}
              onChange={handleChangeFormData2}
            />
            <BasicTextInput
              label={"Street line 2"}
              isRequired={true}
              type={"text"}
              id={"streetLine2"}
              name={"streetLine2"}
              value={formData2?.streetLine2}
              onChange={handleChangeFormData2}
            />

            <MultiTextInput
              label="ZIP, City "
              tooltip="Please enter your zip code and city."
              value1={formData2.zip}
              onChange1={handleChangeFormData2}
              placeholder1="Enter Zip Code"
              id1="zip"
              name1="zip"
              type1="text"
              isRequired1={true}
              value2={formData2.city}
              onChange2={handleChangeFormData2}
              placeholder2="Enter City"
              id2="city"
              name2="city"
              type2="text"
              isRequired2={true}
            />

            <BasicSelectInput
              label={"Country"}
              isRequired={true}
              name={"country"}
              onChange={handleChangeFormData2}
              value={formData2?.country}
              options={countyNameOptions}
              defaultDisabledValue={"🇩🇪 Germany"}
            />
            <BasicSelectInput
              label={"State"}
              isRequired={true}
              name={"state"}
              onChange={handleChangeFormData2}
              value={formData2?.state}
              options={countyNameOptions}
              defaultDisabledValue={"🇩🇪 Germany"}
            />
            <MixedSelectAndInputField
              label="Fax"
              value1={formData2?.countryCode}
              onChange1={handleChangeFormData2}
              options1={countryCodeOptions}
              name1="countryCode"
              defaultDisabledValue1="🇩🇪 +49"
              value2={formData2?.fax}
              onChange2={handleChangeFormData2}
              id2="fax"
              name2="fax"
              isRequired={false}
            />
            <MixedSelectAndInputField
              label="Cell Number"
              value1={formData2?.countryCode}
              onChange1={handleChangeFormData2}
              options1={countryCodeOptions}
              name1="countryCode"
              defaultDisabledValue1="🇩🇪 +49"
              value2={formData2?.cellPhone}
              onChange2={handleChangeFormData2}
              id2="cellPhone"
              name2="cellPhone"
              isRequired={false}
            />
            <BasicTextInput
              label={"Website"}
              isRequired={false}
              type={"text"}
              id={"website"}
              name={"website"}
              value={formData2?.website}
              onChange={handleChangeFormData2}
            />
          </div> */}
          {/* BASIC FORM ######END */}
          {/* <div className="border-b w-full my-8 " /> */}
          {/* TIN ######START */}
          {/* <div>
            <h3 className="lg:text-xl md:text-lg sm:text-lg ">
              Your Taxpayer Identification Number (TIN){" "}
            </h3>
            <p className="text-[14px] mt-2 mb-6">
              Accepted identification numbers: Social Security Number (SSN),
              Employer identification Number (EIN), or Individual Taxpayer
              Identification number (ITIN).
            </p>

            <BasicTextInput
              label={"Tax ID Number"}
              isRequired={true}
              type={"text"}
              id={"taxIdNumber"}
              name={"taxIdNumber"}
              value={formData2?.taxIdNumber}
              onChange={handleChangeFormData2}
              placeholder={""}
            />
          </div> */}

          {/* TIN ######END */}

          {/* <div className="border-b w-full my-8" /> */}
          {/* Taxpayer ID Numbers Within the EU ######START */}
          {/* <div>
            <h3 className="lg:text-xl md:text-lg sm:text-lg ">
              Your Taxpayer ID Numbers Within the EU
            </h3>
            <p className="text-[14px] mt-2 mb-0">
              In order to determine whether we need a taxpayer ID number from
              you, please answer the following question.
            </p>
            <Link className="text-[14px] underline ">DAC7 Data</Link>
            <h4 className="font-medium text-[14px] mb-3 mt-6">
              Do you have permanent establishments or a taxpayer ID number
              within the EU?
            </h4>
            <form className="space-y-3">
              <CustomRadioButton
                label="Yes, I have a taxpayer ID number within the EU."
                id="dac7-relevant"
                name="isTaxIdWithinEU"
                checked={formData2?.isTaxIdWithinEU === true}
                onChange={(e) => handleRadioChange2(e, "dac7-relevant")}
              />
              <CustomRadioButton
                label="No, I do not have a taxpayer ID number within the EU."
                id="not-dac7-relevant"
                name="isTaxIdWithinEU"
                checked={formData2?.isTaxIdWithinEU === false}
                onChange={(e) => handleRadioChange2(e, "dac7-relevant")}
              />
            </form>
          </div> */}
          {/* Taxpayer ID Numbers Within the EU ######END */}
          {/* <div className="border-b w-full my-8" /> */}
          {/* VAT POLICY  ######START */}
          {/* <div>
            <h3 className="lg:text-xl md:text-lg sm:text-lg ">
              Your Value-Added Tax (VAT) Information
            </h3>
            <p className="text-[14px] mt-2 mb-0">
              Since WristLink  is located in Germany, we are subject to EU law.
              Therefore, the recent changes to VAT policy apply to both EU and
              non-EU dealers. Furthermore, we require your German VAT number if
              you ship items to Germany taxed and with duty paid.
            </p>
            <Link className="text-[14px] underline ">VAT information</Link>
            <h4 className="font-medium text-[14px] mb-3 mt-6">
              Do you ship goods from a non-EU country to Germany?
            </h4>
            <form className="space-y-3">
              <CustomRadioButton
                label="Yes! I hereby confirm that I ship goods worth over €150 taxed and with duty paid from a non-EU country to Germany and, thus, commit to providing a valid German VAT number."
                id="vatinfo-relevant"
                name="isShipFromNonEU"
                checked={formData2?.isShipFromNonEU === true}
                onChange={(e) => handleRadioChange2(e, "vatinfo-relevant")}
              />
              <CustomRadioButton
                label="No! I hereby confirm that I do not ship goods worth over €150 taxed and with duty paid from a non-EU country to Germany."
                id="not-vatinfo-relevant"
                name="isShipFromNonEU"
                checked={formData2?.isShipFromNonEU === false}
                onChange={(e) => handleRadioChange2(e, "vatinfo-relevant")}
              />
            </form>
          </div> */}
          {/* VAT POLICY  ######END */}

          {/* CTA TO NEXT PAGE */}
          <div className="flex justify-between items-center w-full my-6">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(1);
              }}
              className="text-sm flex gap-1 items-center"
            >
              {ChevronLeftMini} Previous{" "}
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                nextStep();
              }}
              className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
            >
              Continue to step 3
            </button>
          </div>
        </form>

        <div className="lg:w-4/12 md:w-4/12 pl-6 sm:w-full lg:block md:block sm:hidden">
          <TrialBanner
            icon={"💡"}
            title={"Note"}
            desctiption={
              "Your logo will be displayed next to your listings and on your dealer homepage."
            }
          />
        </div>
      </div>
    </div>
  );
};

const Step3Section = ({
  isActive,
  handleNextStep,
  handleChangeFormData3,
  formData3,
  amount,
  cycle,
}) => {
  const [promo, setPromo] = useState("");

  const handlePayNow = async () => {
    // Step 1: Open the popup immediately
    const popup = window.open("", "_blank", "width=600,height=700");

    // Step 2: Make the async API call
    try {
      const res = await axiosInstance.post(`/payment/paytabs`, {
        amount: amount,
        currency: "AED",
        customerDetails: {
          name: " ",
          email: " ",
          phone: " ",
          country: " ",
          street1: " ",
        },
      });

      // Step 3: Set the URL of the popup
      popup.location.href = res.data.redirect_url;

      // Step 4: Listen for postMessage from the payment window
      const receiveMessage = (event) => {
        // Optional: Validate event.origin
        if (event.data.status === "success") {
          alert("Payment successful!");
          handleNextStep(5);
        } else {
          alert("Payment failed!");
        }
        window.removeEventListener("message", receiveMessage);
      };

      window.addEventListener("message", receiveMessage);
    } catch (err) {
      popup.close(); // Close the blank popup if the API fails
      alert("Error initiating payment");
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPromo(value);
  };

  return (
    <div className={`${isActive ? "block" : "hidden"} gap-4`}>
      <div className="lg:w-8/12 md:w-8/12 sm:w-full">
        <h1 className="lg:text-4xl md:text-3xl sm:text-xl">Payment</h1>
      </div>
      <div className="flex max-w-[500px] items-center gap-6 mt-4">
        <div className="w-8/12">
          <BasicTextInput
            value={promo}
            onChange={handleChange}
            label={"Promo"}
            placeholder={"Enter promo code if you have any"}
          />
        </div>
        <button
          // type="submit"
          // disabled={!stripe || loading}
          style={{
            fontSize: 18,
            borderRadius: 5,
            backgroundColor: "#292929",
            color: "#fff",
          }}
          className="px-4 py-1.5 w-2/12"
          onClick={handlePayNow}
        >
          Claim
        </button>
      </div>

      <div className="my-6 gap-4">
        {/* <StripeCheckout amount={amount} handleNextStep={handleNextStep} /> */}

        <div className="flex gap-6 items-center">
          <button
            // type="submit"
            // disabled={!stripe || loading}
            style={{
              padding: "12px 24px",
              fontSize: 18,
              borderRadius: 5,
              backgroundColor: "#292929",
              color: "#fff",
            }}
            onClick={handlePayNow}
          >
            Make Payment
          </button>
          <div>
            <p className="italic font-bold">
              Payable AED {amount}/{cycle}
            </p>
          </div>
        </div>
        {/* <form className="lg:w-8/12 md:w-8/12 sm:w-full">
          <BasicSelectInput
            label={"State"}
            isRequired={true}
            name={"state"}
            onChange={handleChangeFormData3}
            value={formData3?.state}
            options={["Credit Card", "Debit Card", "Others"]}
            // defaultDisabledValue={"Germany"}
          />
          <p className="text-[14px] mt-2 mb-6">
            Your details will be processed by the certified payment service
            provider Saferpay according to the PCI DSS (Payment Card Industry
            Data Security Standard). While under review, a 1 EUR hold will be
            placed on your account, but not charged. This enables us to verify
            that the details you entered are valid.
          </p>
          <BasicTextInput
            label={"Card holder"}
            isRequired={true}
            type={"text"}
            id={"cardHolder"}
            name={"cardHolder"}
            value={formData3?.cardHolder}
            onChange={handleChangeFormData3}
          />
          <BasicTextInput
            label={"Card number"}
            isRequired={true}
            type={"text"}
            id={"cardNumber"}
            name={"cardNumber"}
            value={formData3?.cardNumber}
            onChange={handleChangeFormData3}
          />

          <div className="lg:w-4/12 md:w-6/12 sm:w-full">
            <BasicTextInput
              label={"Security code (CVC)"}
              isRequired={true}
              type={"text"}
              id={"cvc"}
              name={"cvc"}
              value={formData3?.cvc}
              onChange={handleChangeFormData3}
            />
            <BasicTextInput
              label={"Expiration date"}
              isRequired={true}
              type={"text"}
              id={"expDate"}
              name={"expDate"}
              value={formData3?.expDate}
              onChange={handleChangeFormData3}
            />
          </div>
          <p className="text-[14px] mt-2 mb-6">
            I hereby authorize WristLink to charge my package payments to the
            credit card listed above.
          </p>
          <p className="text-[14px] mt-2 mb-6">
            You will be directed to your bank to verify your credit card.
          </p>


          <div className="flex justify-between items-center w-full my-6">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(2);
              }}
              className="text-sm flex gap-1 items-center"
            >
              {ChevronLeftMini} Previous{" "}
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(5);
              }}
              className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
            >
              Continue to step 4
            </button>
          </div>
        </form> */}

        <div className="flex justify-between items-center w-full my-6">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNextStep(2);
            }}
            className="text-sm flex gap-1 items-center"
          >
            {ChevronLeftMini} Previous{" "}
          </button>
        </div>

        <div className="lg:w-4/12 md:w-4/12 pl-6 sm:w-full lg:block md:block sm:block">
          <TrialBanner
            icon={"💡"}
            title={"Note"}
            desctiption={
              "The payment is fully refundable if the account is not approved."
            }
          />
        </div>
      </div>
    </div>
  );
};

const Step4Section = ({
  isActive,
  handleNextStep,
  handleChangeFormData4,
  formData4,
}) => {
  return (
    <div className={`${isActive ? "block" : "hidden"} gap-4`}>
      <div className="lg:w-8/12 md:w-8/12 sm:w-full">
        <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
          Payout Information
        </h1>
      </div>

      <div className="my-6 flex gap-4">
        <form className="lg:w-8/12 md:w-8/12 sm:w-full">
          <BasicSelectInput
            label={"State"}
            isRequired={true}
            name={"state"}
            onChange={handleChangeFormData4}
            value={formData4?.state}
            options={["Credit Card", "Debit Card", "Others"]}
            // defaultDisabledValue={"Germany"}
          />
          <p className="text-[14px] mt-2 mb-6">
            Your details will be processed by the certified payment service
            provider Saferpay according to the PCI DSS (Payment Card Industry
            Data Security Standard). While under review, a 1 EUR hold will be
            placed on your account, but not charged. This enables us to verify
            that the details you entered are valid.
          </p>
          <BasicTextInput
            label={"Card holder"}
            isRequired={true}
            type={"text"}
            id={"cardHolder"}
            name={"cardHolder"}
            value={formData4?.cardHolder}
            onChange={handleChangeFormData4}
          />
          <BasicTextInput
            label={"Card number"}
            isRequired={true}
            type={"text"}
            id={"cardNumber"}
            name={"cardNumber"}
            value={formData4?.cardNumber}
            onChange={handleChangeFormData4}
          />

          <div className="lg:w-4/12 md:w-6/12 sm:w-full">
            <BasicTextInput
              label={"Security code (CVC)"}
              isRequired={true}
              type={"text"}
              id={"cvc"}
              name={"cvc"}
              value={formData4?.cvc}
              onChange={handleChangeFormData4}
            />
            <BasicTextInput
              label={"Expiration date"}
              isRequired={true}
              type={"text"}
              id={"expDate"}
              name={"expDate"}
              value={formData4?.expDate}
              onChange={handleChangeFormData4}
            />
          </div>
          <p className="text-[14px] mt-2 mb-6">
            I hereby authorize WristLink GmbH to charge my package payments to
            the credit card listed above.
          </p>
          <p className="text-[14px] mt-2 mb-6">
            You will be directed to your bank to verify your credit card.
          </p>

          {/* CTA TO NEXT PAGE */}
          <div className="flex justify-between items-center w-full my-6">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(3);
              }}
              className="text-sm flex gap-1 items-center"
            >
              {ChevronLeftMini} Previous{" "}
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(5);
              }}
              className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
            >
              Continue to step 5
            </button>
          </div>
        </form>

        <div className="lg:w-4/12 md:w-4/12 pl-6 sm:w-full lg:block md:block sm:hidden">
          <TrialBanner
            icon={"💡"}
            title={"Note"}
            desctiption={
              "There's no base fee for the first 30 days. We only charge a commission fee for successful sales. We'll email you two weeks before the end of the trial period and before the first invoice is sent. Of course, you can always cancel at the end of the month. "
            }
          />
        </div>
      </div>
    </div>
  );
};

const Step5Section = ({
  isActive,
  handleNextStep,
  handleSubmitDealerRegistration,
  handleChangeFormData5,
  formData5,
}) => {
  // console.log(handleChangeFormData5, formData5);

  return (
    <div className={`${isActive ? "block" : "hidden"} gap-4`}>
      <div className="lg:w-8/12 md:w-8/12 sm:w-full">
        <h1 className="lg:text-4xl md:text-3xl sm:text-xl">Summary</h1>
      </div>

      <div className="my-6 flex gap-4">
        <form className="lg:w-8/12 md:w-8/12 sm:w-full">
          <p className="text-[14px] mt-2 mb-6">
            Your details will be processed by the certified payment service
            provider Saferpay according to the PCI DSS (Payment Card Industry
            Data Security Standard). While under review, a 1 EUR hold will be
            placed on your account, but not charged. This enables us to verify
            that the details you entered are valid.
          </p>

          <p className="text-[14px] mt-2 mb-6">
            I hereby authorize WristLink to charge my package payments to the
            credit card listed above.
          </p>
          <p className="text-[14px] mt-2 mb-6">
            You will be directed to your bank to verify your credit card.
          </p>

          {/* CTA TO NEXT PAGE */}
          <div className="flex justify-between items-center w-full my-6">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNextStep(3);
              }}
              className="text-sm flex gap-1 items-center"
            >
              {ChevronLeftMini} Previous{" "}
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                handleSubmitDealerRegistration();
              }}
              className="px-12 py-2.5 rounded bg-secondary text-white text-sm"
            >
              Complete Registration!
            </button>
          </div>
        </form>

        {/* <div className="lg:w-4/12 md:w-4/12 pl-6 sm:w-full lg:block md:block sm:hidden">
          <TrialBanner
            icon={"💡"}
            title={"Note"}
            desctiption={
              "There's no base fee for the first 30 days. We only charge a commission fee for successful sales. We'll email you two weeks before the end of the trial period and before the first invoice is sent. Of course, you can always cancel at the end of the month. "
            }
          />
        </div> */}
      </div>
    </div>
  );
};

const StripeCheckout = ({ amount, handleNextStep }) => {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    const createPaymentIntent = async () => {
      const res = await axiosInstance.post(
        "/payment/stripe/create-payment-intent",
        {
          amount,
        }
      );
      setClientSecret(res.data.clientSecret);
    };

    if (amount > 0) {
      createPaymentIntent();
    } else {
      return;
    }
  }, []);

  const appearance = {
    theme: "stripe",
    variables: {
      fontSizeBase: "18px",
      spacingUnit: "12px",
      borderRadius: "8px",
      colorPrimary: "#0d8df8",
      colorBackground: "#ffffff",
      colorText: "#000000",
    },
    rules: {
      ".Input": {
        padding: "14px",
        fontSize: "18px",
      },
      ".Block": {
        width: "100%",
      },
      ".Label": {
        fontSize: "14px",
      },
    },
  };

  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div>
      {clientSecret && (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm
            clientSecret={clientSecret}
            handleNextStep={handleNextStep}
          />
        </Elements>
      )}
    </div>
  );
};

const CheckoutForm = ({ clientSecret, handleNextStep }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {},
      redirect: "if_required",
    });

    if (error) {
      setError(error.message);
    } else if (paymentIntent?.status === "succeeded") {
      e.preventDefault();
      handleNextStep(5);
    }

    setLoading(false);
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ maxWidth: "100%", width: "700px", margin: "0 auto" }}
    >
      <div style={{ marginBottom: 20 }}>
        <PaymentElement />
      </div>
      <button
        type="submit"
        disabled={!stripe || loading}
        style={{
          padding: "12px 24px",
          fontSize: 18,
          borderRadius: 5,
          backgroundColor: "#292929",
          color: "#fff",
        }}
      >
        {loading ? "Processing..." : "Make Payment"}
      </button>
      {error && <div style={{ color: "red", marginTop: 10 }}>{error}</div>}
    </form>
  );
};
